import { OnOnlineApplicationCardQueryItemModel } from 'Models';
import { useSelector } from 'react-redux';
import { CardTransactionsState, storeCardTransactions } from 'Stores/CardTransactions';

const useCardName = (productCode: string, subProductCode: any = null, parrent: boolean = false): string | undefined => {
  const { closeLoopProductList, openLoopProductList } = useSelector(storeCardTransactions) as CardTransactionsState;

  const requestCardCloseLoop = closeLoopProductList?.find((item: OnOnlineApplicationCardQueryItemModel) => {
    return (
      item.ProductCode === productCode &&
      (!parrent ||
        (parrent && (subProductCode ? item.SubProductCode === subProductCode : item.SubProductCode === null)))
    );
  });

  const requestCardOpenLoop = openLoopProductList?.find((item: OnOnlineApplicationCardQueryItemModel) => {
    return (
      item.ProductCode === productCode &&
      (!parrent ||
        (parrent && (subProductCode ? item.SubProductCode === subProductCode : item.SubProductCode === null)))
    );
  });

  return requestCardCloseLoop?.ProductName || requestCardOpenLoop?.ProductName;
};

export default useCardName;
